import { FASHION_PROJECTS } from "../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const Frame = ({ image, tag, className = "", delay = 0 }) => (
    <Reveal className={className} delay={delay}>
        <figure className="group" data-cursor="VIEW" data-testid={`fashion-img-${tag}`}>
            <div className="overflow-hidden bg-[#101010]">
                <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    decoding="async"
                    className="poster-img w-full h-auto"
                />
            </div>
        </figure>
    </Reveal>
);

const Project = ({ project }) => {
    const slug = project.title.toLowerCase().replace(/\s+/g, "-");
    return (
        <div className="mb-20 md:mb-32 last:mb-0" data-testid={`fashion-project-${slug}`}>
            <Reveal className="px-6 md:px-12">
                <div className="flex items-baseline justify-between gap-4 border-b border-[var(--line)] pb-4 mb-8 md:mb-12">
                    <div className="flex items-baseline gap-3 md:gap-5 min-w-0">
                        <span className="font-mono2 text-[10px] md:text-xs text-[var(--red)]">{project.id}</span>
                        <h3 className="font-display text-lg sm:text-2xl md:text-4xl uppercase tracking-tight truncate" data-testid={`fashion-project-title-${slug}`}>
                            {project.title}
                        </h3>
                    </div>
                    <span className="font-mono2 text-[9px] md:text-[10px] tracking-[0.2em] text-[var(--mute)] uppercase whitespace-nowrap">
                        {project.meta}
                    </span>
                </div>
            </Reveal>
            {project.images.length === 1 ? (
                <Reveal>
                    <figure className="group" data-cursor="VIEW" data-testid={`fashion-img-${slug}-1`}>
                        <div className="overflow-hidden bg-[#101010]">
                            <img
                                src={project.images[0].src}
                                alt={project.images[0].alt}
                                loading="lazy"
                                decoding="async"
                                className="poster-img w-full h-auto"
                            />
                        </div>
                    </figure>
                </Reveal>
            ) : (
                <div className="px-6 md:px-12 grid grid-cols-12 gap-x-4 md:gap-x-8 gap-y-10 items-start">
                    <Frame image={project.images[0]} tag={`${slug}-1`} className="col-span-12 sm:col-span-7 md:col-span-6" />
                    <Frame image={project.images[1]} tag={`${slug}-2`} className="col-span-12 sm:col-span-5 md:col-span-4 md:col-start-9 md:mt-32" delay={0.12} />
                </div>
            )}
        </div>
    );
};

export const Fashion = () => (
    <section className="pt-28 md:pt-44" data-testid="fashion-section">
        <SectionHeading index="05" title="Fashion design" id="fashion" />
        {FASHION_PROJECTS.map((p) => (
            <Project key={p.id} project={p} />
        ))}
    </section>
);
